import script from "./AddressForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressForm.vue?vue&type=script&setup=true&lang=ts"

import "./AddressForm.vue?vue&type=style&index=0&id=00e9166e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e9166e"]])

export default __exports__